<template>
  <b-row class="p-2 my-2">
    <!-- Result number and filter category buttons -->
    <b-col md="8" class="text-center">
      <span class="filter-result-txt">{{ resultsNum }} PRODUCT{{ resultsNum > 1 ? 'S' : ''}} FOUND</span>
      <div class="filter-category-parent">
        <b-row class="justify-content-center p-2" v-if="filtersNotEmpty">
          <!-- Filters row -->
          <div
            class="filter-category-btn ml-2 mr-2 pl-1"
            v-for="(filter, i) in appliedFilters"
            :key="filter"
          >
            <span class="ml-2">{{ filter }}</span>
            <button class="delete-category-btn ml-1 mr-1" v-on:click="$emit('remove-filter', i)">
              <font-awesome-icon icon="times"></font-awesome-icon>
            </button>
          </div>

          <!-- Clear All Btn -->
          <button class="clear-all-btn" v-on:click="$emit('clear-all')">Clear All</button>
        </b-row>
      </div>
    </b-col>

    <!-- Sorting options section -->
    <b-col align-self="start" md="4" class="text-center">
      <div>
        <span>Sort by: &nbsp;</span>
        <select class="sort-by-select" v-model="sort" v-on:change="changeSort">
          <option value="1">Featured</option>
          <option value="2">Price: Low to High</option>
          <option value="3">Price: High to Low</option>
        </select>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "FiltersAboveProducts",
  props: {
    appliedFilters: Array,
    resultsNum: Number,
  },
  data() {
    return {
      sort: 1,
    };
  },
  methods: {
    changeSort: function () {
      this.$emit("change-sort", this.sort);
    },
  },
  computed: {
    filtersNotEmpty() {
      return this.appliedFilters.length;
    },
  },
};
</script>

<style>
.filter-category-btn {
  color: #999999;
  border: solid 1px;
  border-radius: 10px;
}

.delete-category-btn {
  color: #999999;
  border: none;
  background-color: transparent;
}

.clear-all-btn {
  border: none;
  background: transparent;
  color: #999999;
}

.sort-by-select {
  border: 1px solid #999999;
  border-radius: 5px;
  padding: 0px 10px;
  background: #f7f7f7;
  height: 32px;
}

.filter-result-txt {
  font-size: small;
  color: #a6a6a6;
}
</style>
